import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "src/services";
import { is } from "src/util/is";

export const useTransactionsWithDateRange = ({ teamId, timeInterval, enabled = true }) => {
  // Create query key that includes timeInterval to trigger refetch when date range changes
  const queryKey = [
    "getTransactionsGraphWithDateRange",
    teamId,
    timeInterval
  ];


  const query = useQuery({
    queryKey,
    queryFn: () => dashboardService.getTransactions(teamId, timeInterval),
    enabled: !is.empty(teamId) && enabled && !is.empty(timeInterval),
    staleTime: 0, // Always refetch when timeInterval changes
    refetchOnWindowFocus: false, // Prevent unnecessary refetches
  });


  return query;
};
